module.exports = __webpack_public_path__ + "img/callback-submission-success.e4f9763.png";